"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _config = _interopRequireDefault(require("../config/config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var API_CONSTANT = '/api/partner/v0/invoices';
var getInvoices = function getInvoices(contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer)).concat(API_CONSTANT, "?contractAccountId=").concat(contractId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
};
function getInvoicePdf(invoiceId, contractAccountId) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer)).concat(API_CONSTANT, "/").concat(invoiceId, "?contractAccountId=").concat(contractAccountId), {}, _RestHelper.default.setXClientHeader({
    responseType: 'blob'
  }, _config.default.CHANNEL_CONFIG.portal));
}
var _default = exports.default = {
  getInvoices: getInvoices,
  getInvoicePdf: getInvoicePdf
};